import { ReferenceDataEditionError } from '../core/domain/errors/ReferenceDataEditionError';
import { ReferenceDataValidationError } from '../core/domain/errors/ReferenceDataValidationError';
import { RoadSection, RoadSectionId } from '../core/domain/Reference';
import { ExternalReferencePort } from '../core/reference/ExternalReferencePort';
import { captureException } from '@sentry/browser';
import axios from 'axios';

export class ExternalReferenceProvider implements ExternalReferencePort {
    constructor(private readonly baseEndpoint: string) {}

    async loadRoadSections(): Promise<RoadSection[]> {
        try {
            const response = await axios.request({
                method: 'GET',
                url: `${this.baseEndpoint}/reference`,
                withCredentials: true,
            });

            return response.data;
        } catch (err) {
            console.error(err);
            captureException(err);
            throw err;
        }
    }

    async editRoadSections(roadSectionIds: RoadSectionId[], data: Partial<RoadSection>): Promise<RoadSection[]> {
        try {
            const response = await axios.request({
                method: 'PATCH',
                url: `${this.baseEndpoint}/reference`,
                data: {
                    roadSectionIds,
                    data,
                },
                withCredentials: true,
            });

            return response.data;
        } catch (err: any) {
            console.error(err);
            captureException(err);
            if (err.response?.status === 422) {
                const error = err.response.data.details[0];
                const field = error.field || 'unknown';
                throw new ReferenceDataValidationError(field);
            } else {
                throw new ReferenceDataEditionError('Error while editing road sections');
            }
        }
    }
}
